export default __webpack_public_path__ + "locales/pt/FillPDFDialog.json?hash=72d2328412ec93a8541cfdf2ab932527";